import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6d00e880 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _7c128ec4 = () => interopDefault(import('..\\pages\\achievement\\index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _3c873b54 = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _50be09a3 = () => interopDefault(import('..\\pages\\products\\index.vue' /* webpackChunkName: "pages/products/index" */))
const _8a05b270 = () => interopDefault(import('..\\pages\\adv-custom\\tender\\index.vue' /* webpackChunkName: "pages/adv-custom/tender/index" */))
const _3e08faec = () => interopDefault(import('..\\pages\\pcas\\loading.vue' /* webpackChunkName: "pages/pcas/loading" */))
const _3d414326 = () => interopDefault(import('..\\pages\\adv-custom\\tender\\banner.vue' /* webpackChunkName: "pages/adv-custom/tender/banner" */))
const _2528ea09 = () => interopDefault(import('..\\pages\\products\\details\\gong-cheng-xiang-mu.vue' /* webpackChunkName: "pages/products/details/gong-cheng-xiang-mu" */))
const _178107ca = () => interopDefault(import('..\\pages\\products\\details\\nong-cun-chan-quan.vue' /* webpackChunkName: "pages/products/details/nong-cun-chan-quan" */))
const _652980b3 = () => interopDefault(import('..\\pages\\products\\details\\qi-ye-jiao-pei.vue' /* webpackChunkName: "pages/products/details/qi-ye-jiao-pei" */))
const _d64a81ce = () => interopDefault(import('..\\pages\\products\\details\\qi-ye-zhao-cai.vue' /* webpackChunkName: "pages/products/details/qi-ye-zhao-cai" */))
const _0b54a42f = () => interopDefault(import('..\\pages\\products\\details\\xing-zheng-fu-wu.vue' /* webpackChunkName: "pages/products/details/xing-zheng-fu-wu" */))
const _19237328 = () => interopDefault(import('..\\pages\\products\\details\\yun-zi-kong-jian.vue' /* webpackChunkName: "pages/products/details/yun-zi-kong-jian" */))
const _7b7369c1 = () => interopDefault(import('..\\pages\\products\\details\\zhao-biao-cai-gou.vue' /* webpackChunkName: "pages/products/details/zhao-biao-cai-gou" */))
const _01ce01ad = () => interopDefault(import('..\\pages\\adv-custom\\tender\\configs\\links.js' /* webpackChunkName: "pages/adv-custom/tender/configs/links" */))
const _f304005e = () => interopDefault(import('..\\pages\\adv-custom\\tender\\mixins\\exclude.js' /* webpackChunkName: "pages/adv-custom/tender/mixins/exclude" */))
const _930f40f0 = () => interopDefault(import('..\\pages\\adv-custom\\tender\\mixins\\source.js' /* webpackChunkName: "pages/adv-custom/tender/mixins/source" */))
const _cde337d0 = () => interopDefault(import('..\\pages\\adv-custom\\tender\\products\\bhtong.vue' /* webpackChunkName: "pages/adv-custom/tender/products/bhtong" */))
const _062766ba = () => interopDefault(import('..\\pages\\adv-custom\\tender\\products\\bid-clearing.vue' /* webpackChunkName: "pages/adv-custom/tender/products/bid-clearing" */))
const _5e9d80d2 = () => interopDefault(import('..\\pages\\adv-custom\\tender\\products\\file-agent.vue' /* webpackChunkName: "pages/adv-custom/tender/products/file-agent" */))
const _2b39dd0f = () => interopDefault(import('..\\pages\\adv-custom\\tender\\products\\shang-ying.vue' /* webpackChunkName: "pages/adv-custom/tender/products/shang-ying" */))
const _64328de2 = () => interopDefault(import('..\\pages\\news\\assets\\js\\news.js' /* webpackChunkName: "pages/news/assets/js/news" */))
const _23b626ea = () => interopDefault(import('..\\pages\\news\\_guid.vue' /* webpackChunkName: "pages/news/_guid" */))
const _62e32d47 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _6d00e880,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/achievement",
    component: _7c128ec4,
    alias: "/achievement/index.html",
    name: "achievement"
  }, {
    path: "/news",
    component: _3c873b54,
    alias: "/news/index.html",
    name: "news"
  }, {
    path: "/products",
    component: _50be09a3,
    alias: "/products/index.html",
    name: "products"
  }, {
    path: "/adv-custom/tender",
    component: _8a05b270,
    alias: "/adv-custom/tender/index.html",
    name: "adv-custom-tender"
  }, {
    path: "/pcas/loading",
    component: _3e08faec,
    alias: "/pcas/loading/index.html",
    name: "pcas-loading"
  }, {
    path: "/adv-custom/tender/banner",
    component: _3d414326,
    alias: "/adv-custom/tender/banner/index.html",
    name: "adv-custom-tender-banner"
  }, {
    path: "/products/details/gong-cheng-xiang-mu",
    component: _2528ea09,
    alias: "/products/details/gong-cheng-xiang-mu/index.html",
    name: "products-details-gong-cheng-xiang-mu"
  }, {
    path: "/products/details/nong-cun-chan-quan",
    component: _178107ca,
    alias: "/products/details/nong-cun-chan-quan/index.html",
    name: "products-details-nong-cun-chan-quan"
  }, {
    path: "/products/details/qi-ye-jiao-pei",
    component: _652980b3,
    alias: "/products/details/qi-ye-jiao-pei/index.html",
    name: "products-details-qi-ye-jiao-pei"
  }, {
    path: "/products/details/qi-ye-zhao-cai",
    component: _d64a81ce,
    alias: "/products/details/qi-ye-zhao-cai/index.html",
    name: "products-details-qi-ye-zhao-cai"
  }, {
    path: "/products/details/xing-zheng-fu-wu",
    component: _0b54a42f,
    alias: "/products/details/xing-zheng-fu-wu/index.html",
    name: "products-details-xing-zheng-fu-wu"
  }, {
    path: "/products/details/yun-zi-kong-jian",
    component: _19237328,
    alias: "/products/details/yun-zi-kong-jian/index.html",
    name: "products-details-yun-zi-kong-jian"
  }, {
    path: "/products/details/zhao-biao-cai-gou",
    component: _7b7369c1,
    alias: "/products/details/zhao-biao-cai-gou/index.html",
    name: "products-details-zhao-biao-cai-gou"
  }, {
    path: "/adv-custom/tender/configs/links",
    component: _01ce01ad,
    alias: "/adv-custom/tender/configs/links/index.html",
    name: "adv-custom-tender-configs-links"
  }, {
    path: "/adv-custom/tender/mixins/exclude",
    component: _f304005e,
    alias: "/adv-custom/tender/mixins/exclude/index.html",
    name: "adv-custom-tender-mixins-exclude"
  }, {
    path: "/adv-custom/tender/mixins/source",
    component: _930f40f0,
    alias: "/adv-custom/tender/mixins/source/index.html",
    name: "adv-custom-tender-mixins-source"
  }, {
    path: "/adv-custom/tender/products/bhtong",
    component: _cde337d0,
    alias: "/adv-custom/tender/products/bhtong/index.html",
    name: "adv-custom-tender-products-bhtong"
  }, {
    path: "/adv-custom/tender/products/bid-clearing",
    component: _062766ba,
    alias: "/adv-custom/tender/products/bid-clearing/index.html",
    name: "adv-custom-tender-products-bid-clearing"
  }, {
    path: "/adv-custom/tender/products/file-agent",
    component: _5e9d80d2,
    alias: "/adv-custom/tender/products/file-agent/index.html",
    name: "adv-custom-tender-products-file-agent"
  }, {
    path: "/adv-custom/tender/products/shang-ying",
    component: _2b39dd0f,
    alias: "/adv-custom/tender/products/shang-ying/index.html",
    name: "adv-custom-tender-products-shang-ying"
  }, {
    path: "/news/assets/js/news",
    component: _64328de2,
    alias: "/news/assets/js/news/index.html",
    name: "news-assets-js-news"
  }, {
    path: "/news/:guid",
    component: _23b626ea,
    alias: "/news/:guid/index.html",
    name: "news-guid"
  }, {
    path: "/",
    component: _62e32d47,
    alias: "/index.html",
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
